/* ============================================================
   Vintage Luxe Up — Mobile sticky PDP CTA
   Reveals .vlu-pdp-sticky when the in-page <product-form>
   scrolls out of view. IntersectionObserver, no library.
   ============================================================ */

(function () {
  'use strict';

  function init() {
    var sticky = document.querySelector('[data-vlu-pdp-sticky]');
    if (!sticky) return;

    // Trigger off the first <product-form> on the page (Dawn renders this
    // inside the buy_buttons block).
    var trigger = document.querySelector('product-form');
    if (!trigger) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          // When the in-page form scrolls OUT of view, show sticky.
          sticky.classList.toggle('is-visible', !entry.isIntersecting);
          sticky.setAttribute('aria-hidden', entry.isIntersecting ? 'true' : 'false');
        });
      },
      { rootMargin: '0px 0px 0px 0px', threshold: 0 }
    );

    observer.observe(trigger);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
